import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import SpinnerDot from "../../components/SpinnerDot";
import auth from "../../firebase/auth";
import useAxiosJwtQuery from "../../hooks/useAxiosJwtQuery";
import CancelConfirmationModal from "../../modals/CancelConfirmationModal";

export default function MyOrders() {
  const navigate = useNavigate();
  const [modalId, setModalId] = useState(null);

  const userEmail = auth.currentUser.email;

  const [orders, refetch] = useAxiosJwtQuery(`/orders/${userEmail}`);

  const handlePay = (_id) => {
    navigate(`/payment/${_id}`);
  };

  return (
    <div class="w-auto">
      <div class="hero-content flex flex-col">
        {modalId && (
          <CancelConfirmationModal
            id={modalId}
            toast={toast}
            refetch={refetch}
          />
        )}

        <ToastContainer />

        <h1 class="text-center text-5xl font-bold">My Orders</h1>

        <div class="card flex-shrink-0 w-full">
          {!orders ? (
            <SpinnerDot />
          ) : !(orders?.length > 0) ? (
            <h1 class="text-center text-5xl text-[teal] font-bold">
              You haven't ordered any products yet!
            </h1>
          ) : (
            <div class="overflow-x-auto">
              <table class="table w-fit mx-auto">
                <thead>
                  <tr>
                    <th></th>
                    <th>Name</th>
                    <th>Quantity</th>
                    <th className="text-center">Status</th>
                  </tr>
                </thead>

                <tbody>
                  {orders.map(
                    ({ _id, name, quantity, status, transactionId }, i) => (
                      <tr key={_id}>
                        <th>{i + 1}</th>
                        <td>{name}</td>
                        <td className="text-center">{quantity}</td>
                        <td className="font-bold text-center">
                          {status !== "UNPAID" ? (
                            <div className="flex flex-col gap-2 items-center">
                              <span className="flex gap-2 items-center">
                                {status}
                              </span>

                              <span className="items-center">
                                Transaction ID:{" "}
                                {transactionId ? transactionId : "N/A"}
                              </span>
                            </div>
                          ) : (
                            <>
                              <button
                                onClick={() => {
                                  handlePay(_id);
                                }}
                                class="modal-button mr-2 btn border-0 bg-blue-600 hover:bg-blue-700"
                              >
                                Pay
                              </button>

                              <label
                                onClick={() => {
                                  setModalId(_id);
                                }}
                                for={_id}
                                className="modal-button btn border-0 bg-red-600 hover:bg-red-700"
                              >
                                Cancel
                              </label>
                            </>
                          )}
                        </td>
                      </tr>
                    )
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
